<form class="mce-form-section">


    <div class="mce-form-field-group">

        <div>
            <mat-checkbox matTooltip="Add a derating factor (which can be greater than 1 to increase the rating) to cater for any special user requirements."
                          [formField]="form().specified">User Defined Factor</mat-checkbox>
        </div>

        @if(form().specified().value()) {

        <div class ="flex-grow">
            <mat-form-field>
                <mat-label>description</mat-label>
                <input matInput type="text" placeholder="description"
                       [formField]="form().description" />
                @for (error of form().description().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

            <div>
                <mat-form-field>
                    <mat-label>factor</mat-label>
                    <input matInput type="number" placeholder="factor"
                           [formField]="form().value" />
                    @for (error of form().value().errors(); track error.kind ) {
                    <mat-error> {{ error.message }} </mat-error> }
                </mat-form-field>
            </div>
        }

    </div>

</form>
